export default {
  drawer: false,
  clientID: '',
  online: navigator.onLine,
};



// WEBPACK FOOTER //
// ./src/store/state.js